import { render, staticRenderFns } from "./InvestmentsSympatiaAccount.vue?vue&type=template&id=331e78e6&scoped=true"
import script from "./InvestmentsSympatiaAccount.vue?vue&type=script&lang=js"
export * from "./InvestmentsSympatiaAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e78e6",
  null
  
)

export default component.exports